<ng-container *isGranted="['ROLE_API_ADMIN']">
  <div class="align-items-center justify-content-between mb-4 d-flex">
    <h1 class="fs-5 fw-bold mb-0">Global turnover</h1>

    <!-- Filters -->
    <div id="filters">
      <!--      <form class="d-flex gap-3 w-100">-->
      <!--        <div class="dropdown mb-0">-->
      <!--          <button class="btn btn-light rounded-pill dropdown-toggle w-100 border-0 shadow-sm" type="button"-->
      <!--                  id="dropdownaccountmanagers" data-bs-toggle="dropdown" aria-expanded="false" name="accountmanager"><i-->
    <!--            class="bi bi-person-fill me-2 text-primary"></i> Account Managers-->
  <!--          </button>-->
  <!--          <ul class="dropdown-menu" aria-labelledby="dropdownAccountmanagers">-->
  <!--            <li><a class="dropdown-item" href="#"><i class="bi bi-person-fill me-2"></i> Tony</a></li>-->
  <!--            <li><a class="dropdown-item" href="#"><i class="bi bi-person-fill me-2"></i> Silvia</a></li>-->
  <!--            <li><a class="dropdown-item" href="#"><i class="bi bi-person-fill me-2"></i> ...</a></li>-->
<!--          </ul>-->
<!--        </div>-->
<!--        <div class="dropdown mb-0">-->
<!--          <button class="btn btn-light rounded-pill dropdown-toggle w-100 border-0 shadow-sm" type="button"-->
<!--                  id="dropdownbrands" data-bs-toggle="dropdown" aria-expanded="false" name="brands"><i-->
<!--            class="bi bi-tags-fill me-2 text-primary"></i> Brands-->
<!--          </button>-->
<!--          <ul class="dropdown-menu" aria-labelledby="dropdownbrands">-->
<!--            <li><a class="dropdown-item" href="#"><i class="bi bi-tags-fill me-2"></i> Padre</a></li>-->
<!--            <li><a class="dropdown-item" href="#"><i class="bi bi-tags-fill me-2"></i> Angela</a></li>-->
<!--            <li><a class="dropdown-item" href="#"><i class="bi bi-tags-fill me-2"></i> Maria</a></li>-->
<!--            <li><a class="dropdown-item" href="#"><i class="bi bi-tags-fill me-2"></i> Christin</a></li>-->
<!--            <li><a class="dropdown-item" href="#"><i class="bi bi-tags-fill me-2"></i> Tara</a></li>-->
<!--          </ul>-->
<!--        </div>-->
<!--        <div class="input-group mb-0">-->
<!--          <input type="text" class="form-control rounded-start-pill border-0 shadow-sm search " placeholder="Search..."-->
<!--                 aria-label="search">-->
<!--          <button type="submit" class="btn btn-primary rounded-end-pill px-3"><i class="bi bi-search"></i></button>-->
<!--        </div>-->
<!--      </form>-->
<!--      <app-timezone-selector [(ngModel)]="timezone" (ngModelChange)="timezoneChanged()"></app-timezone-selector>-->
</div>
<!-- End Filters -->
</div>

<!-- Table -->
<div class="card border-0 shadow mb-3 fade-in-zoom">
  <div class="card-body p-3">
    @if (!statistics.partnerTypes) {
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    }
    @if (statistics.partnerTypes) {
      <div class="table-responsive">
        <table class="table table-hover table-striped align-middle">
          <thead class="bg-tertiary">
            <tr>
              <th></th>
              <th colspan="3">Today</th>
              <th colspan="3">Yesterday</th>
              <th colspan="3">This Month</th>
              <th colspan="3">Last Month</th>
            </tr>
            <tr>
              <th></th>
              <th>Costs</th>
              <th>Revenues</th>
              <th>Margin</th>
              <th>Costs</th>
              <th>Revenues</th>
              <th>Margin</th>
              <th>Costs</th>
              <th>Revenues</th>
              <th>Margin</th>
              <th>Costs</th>
              <th>Revenues</th>
              <th>Margin</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th class="bg-tertiary text-primary">MEDIA BUY</th>
              <td>{{ statistics.partnerTypes.today.mediabuy.cost| money }}</td>
              <td>{{ statistics.partnerTypes.today.mediabuy.revenue| money }}</td>
              <td>{{ statistics.partnerTypes.today.mediabuy.margin| money }} (<span
              [innerHTML]="statistics.partnerTypes.today.mediabuy.getMarginPercent() | coloredPercent"></span>)
            </td>
            <td>{{ statistics.partnerTypes.yesterday.mediabuy.cost| money }}</td>
            <td>{{ statistics.partnerTypes.yesterday.mediabuy.revenue| money }}</td>
            <td>{{ statistics.partnerTypes.yesterday.mediabuy.margin| money }} (<span
            [innerHTML]="statistics.partnerTypes.yesterday.mediabuy.getMarginPercent() | coloredPercent"></span>)
          </td>
          <td>{{ statistics.partnerTypes.thisMonth.mediabuy.cost| money }}</td>
          <td>{{ statistics.partnerTypes.thisMonth.mediabuy.revenue| money }}</td>
          <td>{{ statistics.partnerTypes.thisMonth.mediabuy.margin| money }} (<span
          [innerHTML]="statistics.partnerTypes.thisMonth.mediabuy.getMarginPercent() | coloredPercent"></span>)
        </td>
        <td>{{ statistics.partnerTypes.lastMonth.mediabuy.cost| money }}</td>
        <td>{{ statistics.partnerTypes.lastMonth.mediabuy.revenue| money }}</td>
        <td>{{ statistics.partnerTypes.lastMonth.mediabuy.margin| money }} (<span
        [innerHTML]="statistics.partnerTypes.lastMonth.mediabuy.getMarginPercent() | coloredPercent"></span>)
      </td>
    </tr>
    <tr>
      <th class="bg-tertiary text-primary">AFFILIATES</th>
      <td>{{ statistics.partnerTypes.today.affiliate.cost| money }}</td>
      <td>{{ statistics.partnerTypes.today.affiliate.revenue| money }}</td>
      <td>{{ statistics.partnerTypes.today.affiliate.margin| money }} (<span
      [innerHTML]="statistics.partnerTypes.today.affiliate.getMarginPercent() | coloredPercent"></span>)
    </td>
    <td>{{ statistics.partnerTypes.yesterday.affiliate.cost| money }}</td>
    <td>{{ statistics.partnerTypes.yesterday.affiliate.revenue| money }}</td>
    <td>{{ statistics.partnerTypes.yesterday.affiliate.margin| money }} (<span
    [innerHTML]="statistics.partnerTypes.yesterday.affiliate.getMarginPercent() | coloredPercent"></span>)
  </td>
  <td>{{ statistics.partnerTypes.thisMonth.affiliate.cost| money }}</td>
  <td>{{ statistics.partnerTypes.thisMonth.affiliate.revenue| money }}</td>
  <td>{{ statistics.partnerTypes.thisMonth.affiliate.margin| money }} (<span
  [innerHTML]="statistics.partnerTypes.thisMonth.affiliate.getMarginPercent() | coloredPercent"></span>)
</td>
<td>{{ statistics.partnerTypes.lastMonth.affiliate.cost| money }}</td>
<td>{{ statistics.partnerTypes.lastMonth.affiliate.revenue| money }}</td>
<td>{{ statistics.partnerTypes.lastMonth.affiliate.margin| money }} (<span
[innerHTML]="statistics.partnerTypes.lastMonth.affiliate.getMarginPercent() | coloredPercent"></span>)
</td>
</tr>
<tr>
  <th class="bg-tertiary text-primary">INTERNAL</th>
  <td>{{ statistics.partnerTypes.today.internal.cost| money }}</td>
  <td>{{ statistics.partnerTypes.today.internal.revenue| money }}</td>
  <td>{{ statistics.partnerTypes.today.internal.margin| money }} (<span
  [innerHTML]="statistics.partnerTypes.today.internal.getMarginPercent() | coloredPercent"></span>)
</td>
<td>{{ statistics.partnerTypes.yesterday.internal.cost| money }}</td>
<td>{{ statistics.partnerTypes.yesterday.internal.revenue| money }}</td>
<td>{{ statistics.partnerTypes.yesterday.internal.margin| money }} (<span
[innerHTML]="statistics.partnerTypes.yesterday.internal.getMarginPercent() | coloredPercent"></span>)
</td>
<td>{{ statistics.partnerTypes.thisMonth.internal.cost| money }}</td>
<td>{{ statistics.partnerTypes.thisMonth.internal.revenue| money }}</td>
<td>{{ statistics.partnerTypes.thisMonth.internal.margin| money }} (<span
[innerHTML]="statistics.partnerTypes.thisMonth.internal.getMarginPercent() | coloredPercent"></span>)
</td>
<td>{{ statistics.partnerTypes.lastMonth.internal.cost| money }}</td>
<td>{{ statistics.partnerTypes.lastMonth.internal.revenue| money }}</td>
<td>{{ statistics.partnerTypes.lastMonth.internal.margin| money }} (<span
[innerHTML]="statistics.partnerTypes.lastMonth.internal.getMarginPercent() | coloredPercent"></span>)
</td>
</tr>
<tr>
  <th class="bg-tertiary text-primary">TOTAL</th>
  <td>{{ statistics.partnerTypes.today.totals.cost| money }}</td>
  <td>{{ statistics.partnerTypes.today.totals.revenue| money }}</td>
  <td>{{ statistics.partnerTypes.today.totals.margin| money }} (<span
  [innerHTML]="statistics.partnerTypes.today.totals.getMarginPercent() | coloredPercent"></span>)
</td>
<td>{{ statistics.partnerTypes.yesterday.totals.cost| money }}</td>
<td>{{ statistics.partnerTypes.yesterday.totals.revenue| money }}</td>
<td>{{ statistics.partnerTypes.yesterday.totals.margin| money }} (<span
[innerHTML]="statistics.partnerTypes.yesterday.totals.getMarginPercent() | coloredPercent"></span>)
</td>
<td>{{ statistics.partnerTypes.thisMonth.totals.cost| money }}</td>
<td>{{ statistics.partnerTypes.thisMonth.totals.revenue| money }}</td>
<td>{{ statistics.partnerTypes.thisMonth.totals.margin| money }} (<span
[innerHTML]="statistics.partnerTypes.thisMonth.totals.getMarginPercent() | coloredPercent"></span>)
</td>
<td>{{ statistics.partnerTypes.lastMonth.totals.cost| money }}</td>
<td>{{ statistics.partnerTypes.lastMonth.totals.revenue| money }}</td>
<td>{{ statistics.partnerTypes.lastMonth.totals.margin| money }} (<span
[innerHTML]="statistics.partnerTypes.lastMonth.totals.getMarginPercent() | coloredPercent"></span>)
</td>
</tr>
</tbody>
</table>
</div>
}
</div>
</div>
<!-- End Table -->

<!-- Brand community country -->
<div class="row mb-3 g-3" id="bcc">
  <div class="col-6">
    <div class="card border-0 shadow mb-0 h-100">
      <div class="card-header fw-bold bg-tertiary p-3 border-0">
        <h2 class="fs-6 fw-bold mb-0"><i class="bi bi-tags-fill me-2 text-primary"></i>Brand</h2>
      </div>
      <div class="card-body p-3">
        @if (statistics.products === null) {
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        } @else {
          <table class="table table-hover table-striped align-middle mb-0">
            <thead class="bg-tertiary">
              <tr>
                <th class="app-sortable" (click)="sortProducts('label')">Brand<i class="bi app-sortable-icon" [class]="getSortIcon(productSort, 'label')"></i></th>
                <th class="app-sortable" (click)="sortProducts('cost')">Costs<i class="bi app-sortable-icon" [class]="getSortIcon(productSort, 'cost')"></i></th>
                <th class="app-sortable" (click)="sortProducts('revenue')">Revenues<i class="bi app-sortable-icon" [class]="getSortIcon(productSort, 'revenue')"></i></th>
                <th class="app-sortable" (click)="sortProducts('margin')">Margin<i class="bi app-sortable-icon" [class]="getSortIcon(productSort, 'margin')"></i></th>
              </tr>
            </thead>
            <tbody>
              @for (product of getVisibleRows(statistics.products, productSort); track product) {
                <tr>
                  <td>
                    <img [src]="imageService.getImageUrl(product.logo, 40, 40)" alt=""
                      class="img-fluid rounded-circle w-100 border border-warning brand me-2">
                    <b>{{ product.label }}</b>
                  </td>
                  <td>{{ product.cost | money }}</td>
                  <td>{{ product.revenue | money }}</td>
                  <td [innerHTML]="product.getMarginPercent() | coloredPercent"></td>
                </tr>
              }
            </tbody>
          </table>
          @if (statistics.products.length > topLimit) {
            <div class="text-center mt-2">
              <button type="button" class="btn btn-link btn-sm" (click)="productSort.expanded = !productSort.expanded">
                {{ productSort.expanded ? 'Show less' : 'Show more (' + (statistics.products.length - topLimit) + ')' }}
              </button>
            </div>
          }
        }
      </div>
    </div>
  </div>
  <div class="col-6">
    <div class="card border-0 shadow mb-0 h-100">
      <div class="card-header fw-bold bg-tertiary p-3 border-0">
        <h2 class="fs-6 fw-bold mb-0"><i class="bi bi-translate me-2 text-primary"></i>Community</h2>
      </div>
      <div class="card-body p-3">
        @if (statistics.sites === null) {
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        } @else {
          <table class="table table-hover table-striped align-middle mb-0">
            <thead class="bg-tertiary">
              <tr>
                <th></th>
                <th class="app-sortable" (click)="sortSites('label')">Site<i class="bi app-sortable-icon" [class]="getSortIcon(siteSort, 'label')"></i></th>
                <th class="app-sortable" (click)="sortSites('cost')">Costs<i class="bi app-sortable-icon" [class]="getSortIcon(siteSort, 'cost')"></i></th>
                <th class="app-sortable" (click)="sortSites('revenue')">Revenues<i class="bi app-sortable-icon" [class]="getSortIcon(siteSort, 'revenue')"></i></th>
                <th class="app-sortable" (click)="sortSites('margin')">Margin<i class="bi app-sortable-icon" [class]="getSortIcon(siteSort, 'margin')"></i></th>
              </tr>
            </thead>
            <tbody>
              @for (site of getVisibleRows(statistics.sites, siteSort); track site) {
                <tr>
                  <td><img [src]="'/images/lang/' + site.siteLang + '.svg'" alt="" class="img-fluid w-100 flag"></td>
                  <td>{{ site.label }}</td>
                  <td>{{ site.cost| money }}</td>
                  <td>{{ site.revenue| money }}</td>
                  <td [innerHTML]="site.getMarginPercent() | coloredPercent"></td>
                </tr>
              }
            </tbody>
          </table>
          @if (statistics.sites.length > topLimit) {
            <div class="text-center mt-2">
              <button type="button" class="btn btn-link btn-sm" (click)="siteSort.expanded = !siteSort.expanded">
                {{ siteSort.expanded ? 'Show less' : 'Show more (' + (statistics.sites.length - topLimit) + ')' }}
              </button>
            </div>
          }
        }
      </div>
    </div>
  </div>
</div>
<!-- End Brand community country -->

<!-- Top 10 & diagrammes -->
<div class="row mb-3 g-3">
  <div class="col-6">
    <div class="card border-0 shadow mb-0 h-100">
      <div class="card-header fw-bold bg-light p-3 border-0">
        <h2 class="fs-6 fw-bold mb-0">
          <i class="bi bi-award-fill me-2 text-primary"></i>Top 10 Affiliates
        </h2>
      </div>
      <div class="card-body p-3">
        @if (statistics.topAffiliates === null) {
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        } @else {
          <div class="row">
            <div class="col-6 mx-auto">
              <canvas baseChart
                [data]="topAffiliateChart"
                [type]="chartType"
                [options]="chartOptions">
              </canvas>
            </div>
          </div>

          <table class="table table-hover table-striped align-middle mt-3">
            <thead class="table-light">
              <tr>
                <th>#</th>
                <th>Affiliate</th>
                <th>Earnings</th>
              </tr>
            </thead>
            <tbody>
              @for (topAffiliate of statistics.topAffiliates; track topAffiliate) {
                <tr>
                  <td>{{ topAffiliate.partnerId }}</td>
                  <td>{{ topAffiliate.partnerCompanyName }}</td>
                  <td>{{ topAffiliate.amount| money }}</td>
                </tr>
              }
            </tbody>
          </table>
        }
      </div>
    </div>
  </div>

  <div class="col-6">
    <div class="card border-0 shadow mb-0 h-100">
      <div class="card-header fw-bold bg-light p-3 border-0">
        <h2 class="fs-6 fw-bold mb-0">
          <i class="bi bi-collection-fill me-2 text-primary"></i>Top 10 Media Buy
        </h2>
      </div>
      <div class="card-body p-3">
        @if (statistics.topMediabuyers === null) {
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        } @else {
          <div class="row">
            <div class="col-6 mx-auto">
              <canvas baseChart
                [data]="topMediabuyerChart"
                [type]="chartType"
                [options]="chartOptions">
              </canvas>
            </div>
          </div>

          <table class="table table-hover table-striped align-middle mt-3">
            <thead class="table-light">
              <tr>
                <th>#</th>
                <th>Media Buyer</th>
                <th>Spending</th>
              </tr>
            </thead>
            <tbody>
              @for (topMediabuyer of statistics.topMediabuyers; track topMediabuyer) {
                <tr>
                  <td>{{ topMediabuyer.partnerId }}</td>
                  <td>{{ topMediabuyer.partnerCompanyName }}</td>
                  <td>{{ topMediabuyer.amount| money }}</td>
                </tr>
              }
            </tbody>
          </table>
        }
      </div>
    </div>
  </div>
</div>
</ng-container>
